import { useApiClient } from '@chilipiper/api-client/src/context'
import { skipToken, useQuery } from '@tanstack/react-query'
import {
  getLinkMeetingLimitFromMeetingAttempt,
  getMeetingAttemptLinkResource,
} from '@chilipiper/booking-flow'
import { MeetingAttemptResponseV3 } from '@chilipiper/api-client/src/user-availability'
import { PublicMeetingType } from '@chilipiper/api-client/src/meeting-types'

export const useMeetingAttemptLinkResource = (
  tenantId: string,
  meetingAttempt?: MeetingAttemptResponseV3
) => {
  const { teamScheduling, handoff, meetingTypes, teamSchedulingV2, teamSchedulingV3 } =
    useApiClient()
  const enabled = meetingAttempt && meetingAttempt.type !== 'NotFound'
  return useQuery({
    queryKey: [
      'meeting-attempt-link-resource',
      tenantId,
      meetingAttempt?.type !== 'NotFound'
        ? meetingAttempt?.attempt.id
        : 'meeting-attempt-not-found',
    ],
    queryFn: () =>
      getMeetingAttemptLinkResource(
        tenantId,
        handoff,
        teamScheduling,
        teamSchedulingV2,
        teamSchedulingV3,
        meetingTypes,
        meetingAttempt
      ) ?? null,
    enabled,
  })
}

export const useMeetingAttemptLinkMeetingLimit = ({
  tenantId,
  meetingAttempt,
  meetingType,
}: {
  tenantId: string
  meetingAttempt?: MeetingAttemptResponseV3
  meetingType?: PublicMeetingType
}) => {
  const { teamScheduling, teamSchedulingV2 } = useApiClient()
  const attempt = meetingAttempt && meetingAttempt.type !== 'NotFound' ? meetingAttempt : undefined

  return useQuery({
    queryKey: [tenantId, attempt?.attempt.id, meetingType?.id, 'meeting-attempt-link-limit'],
    queryFn:
      tenantId && attempt && meetingType
        ? () =>
            getLinkMeetingLimitFromMeetingAttempt(
              tenantId,
              teamScheduling,
              teamSchedulingV2,
              attempt,
              meetingType
            )
        : skipToken,
  })
}
